import React, { Component } from 'react';

import IconButton from '@material-ui/core/IconButton';
import LoadingSpinner from '../../common/components/loading-spinner';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    container: {
        'float': 'right',
        margin: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px 0 0`,
        padding: 0,
    },
    downloadBtnLabel: {
        height: 24,
        width: 24,
    },
    menuClass: {
        marginLeft: '-6%'
    },
    menuItemsWrapper: {
        '&:focus': {
            outline: 'none'
        }
    }
} );

export class DownloadMenu extends Component{
    state = {
        exportMenuEl: null,
    };

    handleClick = event => {
        this.setState( { exportMenuEl: event.currentTarget } );
    };

    handleDownload = () => {
        const { exportToImage } = this.props;
        this.handleClose();
        exportToImage();
    };

    handleClose = () => {
        this.setState( { exportMenuEl: null } );
    };

    handleExportToCSV = () => {
        this.props.exportToCSV();

        this.handleClose();
    }

    render(){
        const { exportMenuEl } = this.state;
        const { classes, isFetchingImage, exportToImage, exportToCSV } = this.props;
        const open = exportMenuEl ? true : false;
        return (
            <div className="no-print">
                <div className={classes.container}>
                    {
                        isFetchingImage ?
                            <LoadingSpinner size="small" /> : (
<>
                                <IconButton
                                    classes={{ label: classes.downloadBtnLabel }}
                                    aria-owns={exportMenuEl ? 'download-menu' : undefined}
                                    aria-haspopup="true"
                                    data-automation-id="download-menu-icon"
                                    onClick={this.handleClick}
                                >
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu
                                    id="download-menu"
                                    anchorEl={exportMenuEl}
                                    open={open}
                                    onClose={this.handleClose}
                                    className={isFetchingImage ? classes.menuClass : null}
                                >
                                    {
                                        <div className={classes.menuItemsWrapper}>
                                            {
                                                exportToImage &&
                                                    <MenuItem onClick={this.handleDownload} data-automation-id="download-menu-image-option">Download image</MenuItem>
                                            }
                                            {
                                                exportToCSV &&
                                                    <MenuItem onClick={this.handleExportToCSV} data-automation-id="download-menu-data-option">Export data</MenuItem>
                                            }
                                        </div>
                                    }
                                </Menu>
                            </>
                            )}
                </div>
            </div>
        );
    }
}

DownloadMenu.propTypes = {
    classes: PropTypes.object,
    exportToCSV: PropTypes.func,
    exportToImage: PropTypes.func,
    isFetchingImage: PropTypes.bool,
};

DownloadMenu.defaultProps = {
    isFetchingImage: false
};

export default( withStyles( styles )( DownloadMenu ) );
